<template>
  <div>
    
    <div class="row mt-4">
      <div class="col-md-8">
        <input class="input form-control"
               @keypress.enter="find()"
               v-model="query.generic"
               placeholder="Pesquisar por Chave">
        <search-icon @click="find()" class="icon icon-within"/>
      </div>
      
      <button class="col-md-1 ml-2 btn-sm btn-outline"
              :class="{ 'btn-outline-active': showFilter }"
              @click="showFilter = !showFilter">
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>
      
      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>
    
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters :query="query" @clearBadge="find()" @clearAllBadges="find()"
                      :amount-changed="updateNumberOfBadges"
                      :filters="[filterType, filterStartDate, filterEndDate, filterSuccess]"/>
      </div>
    </div>
    
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-3">
          <label for="event-important">Sucesso?</label>
          <select v-model="query.success" id="event-important" class="form-control">
            <option v-for="opt in filterSuccess.table" :value="opt.value" :key="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>
        
        <div class="col-md-3">
          <label>Tipo do documento</label>
          <Select2 :options="filterType" v-model="query.type"/>
        </div>
        
        <div class="col-md-3">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>
        
        <div class="col-md-3">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
        
      </div>
    </template>
    <hr>
    
    <div class="row">
      <div class="col-sm-12">
        
        <div class="row mt-4">
          <div class="col-md-12">
            <strong>
              {{infoTotalModels}}
            </strong>
          </div>
        </div>
        
        <table class="table table-borderless table-align table-h51">
          <thead>
            <tr>
              <th>Tipo</th>
              <th>Origem</th>
              <th>Chave</th>
              <th>Status</th>
              <th>Tentativas</th>
              <th>Configuração</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th>Detalhes</th>
            </tr>
          </thead>
          <tbody>
          <tr v-for="event in fiscalDocumentEvents" :key="event.id">
            <td :class="buildClass(event)">
              {{ event.type }}
            </td>
            <td>{{ event.origin }}</td>
            <td>{{ event.key }}</td>
            <td>{{ event.success | status }}</td>
            <td>{{ event.attempts }}</td>
            <td>
              <router-link :to="`/unico_integration/settings/${event.settingId}`" target="_blank">
                {{ event.settingName }}
              </router-link>
            </td>
            <td>{{ event.createdAt | datetime }}</td>
            <td>{{ event.updatedAt | datetime }}</td>
            <td>
              <button @click="showDetail(event)" class="btn btn-outline">
                Detalhes
              </button>
            </td>
          </tr>
          </tbody>
        </table>
        
        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>
      
      </div>
    </div>
    
    <Modal v-if="currentEvent" v-model="showModal">
      <div slot="header">
        <p><strong>{{ currentEvent.key }}</strong></p>
      </div>
      
      <div class="row">
        <div class="col-md-6">
          <p><strong>Tipo: </strong>{{ currentEvent.type }}</p>
          <p><strong>Origem: </strong>{{ currentEvent.origin }}</p>
          <p><strong>Chave: </strong>{{ currentEvent.key }}</p>
          <p><strong>Status: </strong>{{ currentEvent.success | status }}</p>
        </div>
        <div class="col-md-6">
          <p><strong>Tentativas: </strong>{{ currentEvent.attempts }}</p>
          <p><strong>Configuração: </strong>{{ currentEvent.settingName }}</p>
          <p><strong>Atualizado em: </strong>{{ currentEvent.createdAt | datetime }}</p>
          <p><strong>Criado em: </strong>{{ currentEvent.updatedAt | datetime }}</p>
        </div>
      </div>
      
      <hr>
      <h3>Retorno</h3>
      <div class="event-detail">
        <VueJsonPretty :data='currentEvent.response'
                       :deep='2'
                       :showLength='true'
                       :showLine='true'/>
      </div>
    
      <template v-if="currentEvent.sendPayload && Object.keys(currentEvent.sendPayload).length > 0">
        <hr>
        <h3>Payload</h3>
        <div class="event-detail">
          <VueJsonPretty :data="currentEvent.sendPayload"
                         :deep="1"
                         :showLength="true"
                         :showLine="true"/>
        </div>
        
        <button class="btn btn-outline mt-3 form-control" @click="resend">
          Reenviar
        </button>
      </template>
    
    </Modal>
  
  </div>
</template>

<script>
import BadgeFilters from '@/components/shares/BadgeFilters'
import Pagination from '@/components/shares/specialTag/Pagination'
import Modal from '@/components/shares/specialTag/Modal'
import ModelMapper from '@/mixins/ModelMapper'
import Select2 from '@/components/shares/Select2'
import VueJsonPretty from 'vue-json-pretty'
import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'

import { Converter } from '@/models/converter'
import { Filter } from '@/models/filter'

import 'vue-json-pretty/lib/styles.css'

export default {
  components: { BadgeFilters, ChevronDownIcon, Modal, Pagination, SearchIcon, Select2, VueJsonPretty },
  computed: {
    fiscalDocumentEvents() {
      return this.getModels || []
    }
  },
  created() {
    const date = new Date()
    date.setDate(date.getDate())
    this.$set(this.query, 'startDate', date.toISOString().substring(0, 10))
    
    this.addOrderBy('createdAt')
    
    this.defaultModelSetting.updateQueryURL = true
    this.asyncTemplateSelect({
      byURL: true,
      pagination: true
    })
  },
  data: () => ({
    currentEvent: null,
    filterEndDate: new Filter({
      key: 'endDate',
      label: 'Data final',
      type: 'date'
    }),
    filterStartDate: new Filter({
      key: 'startDate',
      label: 'Data inicial',
      type: 'date'
    }),
    filterSuccess: new Filter({
      key: 'success',
      label: 'Sucesso',
      table: [
        ['Todos', ''],
        ['Sim', 'true'],
        ['Não', 'false'],
      ]
    }),
    filterType: new Filter({
      key: 'type',
      label: 'Tipo',
      table: ['NFe', 'NFSe', 'CTe', 'CTeOS', 'GTVe']
    }),
    modelPathPrefix: 'unico_integration',
    nameModel: 'FiscalDocumentEvent',
    showModal: false,
  }),
  filters: {
    status(value) {
      return value ? 'Enviado com sucesso!' : 'Falha no envio!'
    }
  },
  methods: {
    buildClass(event) {
        return event.success ? 'marker-green' : 'marker-red'
    },
    find() {
      this.asyncTemplateSelect()
    },
    resend() {
      if (!confirm('Tem certeza?'))
        return
      
      this.openLoad()
      this.axios.put(`/unico_integration/fiscal_document_events/${this.currentEvent.id}/resend`)
        .then(response => this.updateEventAndCurrentEvent(response.data))
        .catch(e => console.log({e}))
        .finally(() => this.closeLoad())
    },
    showDetail(event) {
      this.currentEvent = event
      this.showModal = true
    },
    toCamelcase(data) {
      return new Converter({
        converterName: 'camelcase',
        data: data,
        deep: 0
      }).perform()
    },
    updateEventAndCurrentEvent(data) {
      data = this.toCamelcase(data)
      const event = this.fiscalDocumentEvents.find(e => e.id === this.currentEvent.id)
      
      Object.keys(data).forEach(key => {
        if (key === 'settingName')
          return
        
        event[key] = data[key]
        this.currentEvent[key] = data[key]
      })
    }
  },
  mixins: [ModelMapper],
  name: 'FiscalDocumentEvent'
}
</script>

<style scoped>

.error {
  background-color: indianred;
}

.danger {
  background-color: yellowgreen;
}

.event-detail * {
  background: #051724;
  color: #FFF;
  padding: 16px;
  border-radius: 8px;
}

.rotate-90 {
  transform: rotate(180deg);
}

.fa-angle-right {
  transition: transform .2s;
  margin-left: 8px;
}

.event-message::selection {
  background: #e74c3c;
}

</style>
